import React from 'react';

export const ScaledWrapper = ({
  maxHeight,
  children,
  scale = 1,
}: {
  maxHeight: number;
  children: React.ReactNode;
  scale?: number;
}): React.ReactElement => {
  return (
    <div
      id="scaled-wrapper"
      style={{
        maxHeight,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          width: `${100 / scale}%`,
        }}
      >
        {children}
      </div>
    </div>
  );
};
